import React from 'react';
import CocardParticipantRedemptionIndex from './components/CocardParticipantRedemptionIndex.jsx';

const CocardParticipantRedemption = () => <CocardParticipantRedemptionIndex />;

export default CocardParticipantRedemption;
